import React from "react";
import { TelephoneFill } from "react-bootstrap-icons";
import { faqContacts } from "../data/faq-data";

const FaqContactCard = () => {
  const { emergencyPhone, supportUsEmail, supportIntlEmail, newClientEmail } =
    faqContacts;

  return (
    <aside className="faq-urgent">
      <div className="faq-urgent__icon" aria-hidden="true">
        <TelephoneFill />
      </div>
      <div className="faq-urgent__body">
        <h2 className="faq-urgent__title">
          Need urgent help with your accommodation?
        </h2>
        <p className="faq-urgent__text">
          Our emergency line is available 24/7/365. If anyone is in immediate
          danger, contact local emergency services first.
        </p>
        <p className="faq-urgent__note">
          Non-urgent questions:{" "}
          <a href={`mailto:${supportUsEmail}`}>{supportUsEmail}</a> for stays in
          the United States,{" "}
          <a href={`mailto:${supportIntlEmail}`}>{supportIntlEmail}</a> for
          stays outside the United States. New client? Write to{" "}
          <a href={`mailto:${newClientEmail}`}>{newClientEmail}</a>.
        </p>
      </div>
      <a
        className="faq-urgent__phone"
        href={`tel:+${emergencyPhone.replace(/\D/g, "")}`}
      >
        {emergencyPhone}
      </a>
    </aside>
  );
};

export default FaqContactCard;
